import { escapeAttr, escapeHtml, linkAttrs, } from "@emkit/builder-core";
export const PRICING_DEFAULTS = {
    plans: [
        {
            id: "p1",
            name: "Starter",
            price: "$0",
            period: "/mo",
            description: "For side projects",
            features: ["1 project", "Community support", "1 GB storage"],
            ctaLabel: "Start free",
            ctaHref: "#",
        },
        {
            id: "p2",
            name: "Pro",
            price: "$19",
            period: "/mo",
            description: "For growing teams",
            features: [
                "Unlimited projects",
                "Priority support",
                "100 GB storage",
                "Custom domain",
            ],
            ctaLabel: "Start Pro",
            ctaHref: "#",
            highlight: true,
            highlightBadge: "Most popular",
        },
        {
            id: "p3",
            name: "Team",
            price: "$49",
            period: "/mo",
            description: "For companies",
            features: ["Everything in Pro", "5 seats included", "SSO / SAML", "Audit log"],
            ctaLabel: "Start Team",
            ctaHref: "#",
        },
    ],
    columns: 3,
    accent: "#111827",
    background: "transparent",
    cardBackground: "#ffffff",
    textColor: "#0f172a",
};
export const pricingWidget = {
    type: "pricing",
    defaultProps: PRICING_DEFAULTS,
    renderHtml(props) {
        const plans = props.plans ?? [];
        if (plans.length === 0) {
            return `<div class="emk-pricing" style="padding:12px;color:#9ca3af;font-size:13px;text-align:center;border:1px dashed #e5e7eb;border-radius:6px">(Empty pricing — add plans in the inspector)</div>`;
        }
        const cols = props.columns ?? 3;
        const accent = props.accent ?? "#111827";
        const bg = props.background ?? "transparent";
        const cardBg = props.cardBackground ?? "#ffffff";
        const text = props.textColor ?? "#0f172a";
        const gridStyle = [
            "display:grid",
            `grid-template-columns:repeat(${cols},minmax(0,1fr))`,
            "gap:20px",
            "max-width:1200px",
            "margin:0 auto",
            "font-family:inherit",
        ].join(";");
        const cards = plans
            .map((plan) => {
            const cardStyle = [
                "display:flex",
                "flex-direction:column",
                "padding:28px 24px",
                "border-radius:12px",
                plan.highlight
                    ? `background:${accent};color:#fff;border:1px solid ${accent};box-shadow:0 8px 24px rgba(0,0,0,0.12)`
                    : `background:${cardBg};color:${text};border:1px solid rgba(0,0,0,0.08)`,
                "position:relative",
            ].join(";");
            const badge = plan.highlight && plan.highlightBadge
                ? `<div style="position:absolute;top:-12px;left:50%;transform:translateX(-50%);background:#fff;color:${accent};padding:4px 12px;border-radius:999px;font-size:12px;font-weight:600;letter-spacing:0.02em">${escapeHtml(plan.highlightBadge)}</div>`
                : "";
            const description = plan.description
                ? `<p style="margin:4px 0 0;opacity:0.7;font-size:14px">${escapeHtml(plan.description)}</p>`
                : "";
            const period = plan.period
                ? `<span style="font-size:16px;opacity:0.7;font-weight:400">${escapeHtml(plan.period)}</span>`
                : "";
            const features = (plan.features ?? [])
                .map((f) => `<li style="display:flex;align-items:flex-start;gap:10px;font-size:15px;line-height:1.5"><span style="flex-shrink:0;color:${plan.highlight ? "#fff" : accent};font-weight:700">✓</span><span>${escapeHtml(f)}</span></li>`)
                .join("");
            const ctaStyle = plan.highlight
                ? `background:#fff;color:${accent};border:1px solid #fff`
                : `background:${accent};color:#fff;border:1px solid ${accent}`;
            const cta = `<a href="${escapeAttr(plan.ctaHref)}"${linkAttrs(plan.ctaHref, plan.ctaTarget)} class="emk-pricing-cta" style="display:inline-flex;align-items:center;justify-content:center;padding:12px 18px;margin-top:auto;border-radius:8px;font-weight:500;font-size:15px;text-decoration:none;${ctaStyle}">${escapeHtml(plan.ctaLabel)}</a>`;
            return `<div class="emk-pricing-plan" style="${cardStyle}">${badge}<div><h3 style="margin:0;font-size:18px;font-weight:600">${escapeHtml(plan.name)}</h3>${description}</div><div style="margin:20px 0"><span style="font-size:40px;font-weight:700;letter-spacing:-0.02em">${escapeHtml(plan.price)}</span>${period}</div><ul style="list-style:none;padding:0;margin:0 0 24px;display:flex;flex-direction:column;gap:10px">${features}</ul>${cta}</div>`;
        })
            .join("");
        return `<div class="emk-pricing" style="background:${bg};padding:20px 0"><div style="${gridStyle}">${cards}</div></div>`;
    },
};
//# sourceMappingURL=pricing.js.map